import React from "react";
import { Box, Typography, Paper, Link, Skeleton } from "@mui/material";
import { useSectionData } from "../hooks/useFirebaseData";
import AccessSkeleton from "./ui/AccessSkeleton";

const Access = () => {
  const {
    data: accessData,
    loading,
    error,
  } = useSectionData("access", "access");

  if (error) {
    return (
      <Box
        sx={{
          padding: 5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh",
        }}
      >
        <Typography sx={{ color: "error.main" }}>
          データの読み込み中にエラーが発生しました
        </Typography>
      </Box>
    );
  }

  if (!loading && !accessData) {
    return null;
  }

  if (loading) {
    return 
    <AccessSkeleton/>
  }

  return (
    <Box
      sx={{
        padding: 5,
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 4,
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <Box sx={{ flex: 1, p: 2, width: "100%" }}>
        {accessData.maps && accessData.maps.map((map, index) => (
          <Box key={index} sx={{ mb: 4 }}>
            <iframe
              title={map.title}
              src={map.src}
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: "8px" }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </Box>
        ))}
      </Box>

      <Box
        sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 4, p: 2 }}
      >
        <Typography
          variant="h5"
          sx={{
            textAlign: "center",
            color: "#E87F11",
            fontWeight: "bold",
            marginBottom: 2,
            fontSize: { xs: "1.5rem", md: "1.75rem" },
          }}
        >
          {accessData.title}
        </Typography>

        {accessData.sections && accessData.sections.map((section, index) => (
          <Paper key={index} sx={{ p: 3, boxShadow: 3, borderRadius: "8px" }}>
            <Typography
              variant="subtitle1"
              sx={{
                color: "#E87F11",
                fontWeight: "bold",
                marginBottom: 1,
                fontSize: { xs: "1.25rem", md: "1.5rem" },
              }}
            >
              {section.title}
            </Typography>
            
            {section.type === 'link' ? (
              <Link
                href={section.url}
                target="_blank"
                rel="noopener"
                sx={{
                  color: "#E87F11",
                  fontSize: { xs: "1.25rem", md: "1.50rem" },
                  textDecoration: "underline",
                }}
              >
                {section.content}
              </Link>
            ) : (
              <Typography
                variant="body1"
                sx={{
                  color: "#E87F11",
                  fontSize: { xs: "1.25rem", md: "1.50rem" },
                }}
              >
                {section.content}
              </Typography>
            )}
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default Access;